import {
  Card,
  CardBody,
  CardFooter,
  IconButton,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import { BASEURL, calculateDaysLeft } from "../../../util"
import useSWR from "swr"
import {
  CustomBarChart,
  CustomDeleteModal,
  CustomPieChart,
  DetailDrawer,
  HeaderIcon,
  RenderDetail,
} from "../../../components"
import { CampaignType } from "../../../types/campaign"
import { UserType } from "../../../types/user"
import dayjs from "dayjs"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import { RiAdminLine, RiCustomerService2Line } from "react-icons/ri"
import { MdOutlinePolicy } from "react-icons/md"
import { FaMoneyBillWave } from "react-icons/fa6"
import { TbPencilDiscount } from "react-icons/tb"
import { INSURANCECOMPANYDASHBOARD } from "../../../GraphQl/queries"
import { useQuery } from "@apollo/client"
import { InsuranceDahboardType } from "../../../types/query"
import logo from "../../../assets/no-data.jpg"
import CustomVolumeBarChart, {
  CustomPremiumNumberBarChart,
} from "../../../components/charts/barChart"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import UserAccountOverview from "./UserAccountOverview"


interface DashboardData {
  overview: {
    total_written_premium: number;
    outstanding_premium: number | null;
    new_policy: number;
    lapse_policy: number;
    renewed_policy: number;
    active_policy: number;
    total_staff: number;
    total_agents: number;
    total_brokers: number;
    policyholders: number;
    total_taxes: number;
    all_commissions: number;
    paid_commissions: number;
    outstanding_commissions: number;
  };
  premium_per_business_class: {
    name: string;
    total_premium: number;
  }[];
  premiums_number_per_business_class: {
    name: string;
    record_count: number;
  }[];
  volumes_generated_by_staff: {
    [month: string]: number;
  };
}


function DashboardOverview() {
  const {
    companyId,
    roleId,
    usertype,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const [selectedyear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<DashboardData | null>(null);
  const [insurance_companies_graph_data, setInsuranceCompaniesGraphData] =
    useState<DashboardData | null>(null);


  const fetchDashboardData = async () => {
    setLoading(true);

    // Construct the URL conditionally
    const url =
      selectedyear !== 0
        ? `get-dashboard-overview?company_id=${companyId}&year=${selectedyear}`
        : `get-dashboard-overview?company_id=${companyId}`;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/${url}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      setData(data);
      setInsuranceCompaniesGraphData(data);
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    } finally {
      setLoading(false);
    }
  };





  // Optional: trigger fetch when selected year changes
  useEffect(() => {
    fetchDashboardData();
  }, [selectedyear])

  console.log("selectedyear", selectedyear)


  const NoData = () => (
    <div className="flex flex-col items-center justify-center">
      <p className="text-center text-gray-500 text-3xl">No data available</p>
    </div>
  );





  const userObj = {
    name: stateUser?.user_type === "company_administrator" ? stateUser?.name + " Administrator" : stateUser?.name,
  };

  return (
    <>
      <UserAccountOverview
        user={userObj}
        selectedyear={selectedyear}
        setSelectedYear={setSelectedYear}
      />
      {/* <CustomHeader title={`Overview`} /> */}
      <div className="w-full mt-4">
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:lg:gap-4 lg:gap-5">
          <Card className="bg-brand-success rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.total_agents}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Clients</Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-brand-purple rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.total_staff}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Staff</Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-brand-danger rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.policyholders}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Policyholders</Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-brand-info rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.total_brokers}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Brokers</Typography>
              </div>
              <RiAdminLine size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-[#003566] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.active_policy}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Active Policies</Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>

          <Card className="bg-[#004e98] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.new_policy}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">New Policies</Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#b1740f] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.renewed_policy}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Renewed Policies</Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#403d39] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? <Spinner className="mb-2 text-white" /> : data?.overview?.lapse_policy}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">Lapsed Policies</Typography>
              </div>
              <TbPencilDiscount size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-cyan rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.total_taxes as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Total tax
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-cyan rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.total_written_premium as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Written Premium
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-red-400 rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.total_written_premium) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Premiums Paid
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-green rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (0)
                      // (data?.premium_outstanding[0]
                      //   ?.total_amount_sold as any) ?? 0
                      .toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Premiums Outstanding
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-brand-gray rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.all_commissions as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#451e31] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.paid_commissions as any) ??
                      0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions Paid
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>
          <Card className="bg-[#abc4ff] rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
            <div className="flex flex-row justify-between">
              <div>
                <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                  {loading ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GHS " +
                    (
                      (data?.overview?.outstanding_commissions as any) ?? 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  Commissions Outstanding
                </Typography>
              </div>
              <FaMoneyBillWave size={28} color="#cbcbcb" />
            </div>
          </Card>



        </div>
        <div className="mt-6 w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 md:lg:gap-4 lg:gap-5"></div>
      </div>
      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-2">
        {/* Premiums per Class of Business */}
        <div className="rounded-xl bg-white py-3">
          <span className="text-sm px-3 mb-4 font-semibold">
            Premiums per Class of Business
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {loading ? (
              <Spinner />
            ) : insurance_companies_graph_data?.premium_per_business_class
              ?.length ? (
              <CustomBarChart
                data={insurance_companies_graph_data?.premium_per_business_class}
              />
            ) : (
              <NoData />
            )}
          </div>
        </div>

        {/* Premium number per class */}
        <div className="rounded-xl bg-white py-3">
          <span className="text-sm px-3 mb-4 font-semibold">
            Premium number per class
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {loading ? (
              <Spinner />
            ) : insurance_companies_graph_data?.premiums_number_per_business_class
              ?.length ? (
              <CustomPremiumNumberBarChart
                data={
                  insurance_companies_graph_data?.premiums_number_per_business_class
                }
              />
            ) : (
              <NoData />
            )}
          </div>
        </div>
      </div>

      <div className="grid gap-6 my-7 grid-cols-1 lg:grid-cols-1">
        {/* Volumes generated by staff */}
        <div className="rounded-xl bg-white p-3 col-span-2">
          <span className="text-sm p-3 mb-4 font-semibold">
            Volumes generated by staff
          </span>
          <div className="h-96 w-full mt-10 flex items-center justify-center">
            {loading ? (
              <Spinner />
            ) : insurance_companies_graph_data?.volumes_generated_by_staff &&
              Object.keys(
                insurance_companies_graph_data.volumes_generated_by_staff
              ).length > 0 ? (
              <CustomVolumeBarChart
                data={insurance_companies_graph_data.volumes_generated_by_staff}
              />
            ) : (
              <NoData />
            )}
          </div>
        </div>
      </div>


      <div className="my-28"></div>
    </>
  )
}

export default DashboardOverview
